export default __webpack_public_path__ + "static/media/dodecagon.fd43a130.png";